import React, { useEffect, useState, useContext } from 'react';
import { BrowserRouter as Router, Switch, Route, useParams } from "react-router-dom";
import FormColumn from "components/Common/FormColumn";
import moment from 'moment';
import DataService from "infrastructure/Services/DataService";
import ApiService from "infrastructure/Services/ApiService";
import { Card, CardHeader, CardBody, NavItem, NavLink, Nav, Container, Row, Col, Button, Input } from "reactstrap";
import Loader from 'components/Common/Loader';
import UserContext from "context/UserContext";
import StorageService from 'infrastructure/StorageService';
import Constants from 'infrastructure/Constants';
import { toast } from 'react-toastify';
import { CirclePicker } from 'react-color';
import RiskMatrix from 'components/Common/RiskMatrix';
import { method } from 'lodash';
import logo from '../../assets/img/logo.svg';
export default ((props) => {
  const [booking, setBooking] = useState();
  const [technicianNotes, setTechnicianNotes] = useState();
  const { id } = useParams();
  const { date } = useParams();
  const user = useContext(UserContext);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const tempPeriods = await DataService.periods();
    const campuses = await DataService.labBookings.campuses();

    ApiService.get(`booking/lab/${date}/${id}`)
      .then(resp => {
        //get periods
        var startPeriod = tempPeriods.find(m => m.id === resp.startPeriod);
        var endPeriod = tempPeriods.find(m => m.id === resp.endPeriod);
        var campus = campuses.find(m => m.id === resp.campusId);
        resp.startPeriod = startPeriod.order;
        resp.campus = campus.name;
        var startTime = startPeriod.startTime.split(':');
        resp.startHour = startTime[0];
        resp.startMinute = startTime[1];
        resp.startPeriodName = startPeriod.name;

        var endtime = endPeriod.startTime.split(':');
        resp.endHour = endtime[0];
        resp.endMinute = endtime[1];
        resp.endPeriod = endPeriod.order;
        resp.endPeriodName = endPeriod.name;
        setTechnicianNotes(resp.technicianNotes);
        setBooking(resp);
      })
  }


  const saveTechnicianNotes = () => {
    ApiService.put(`booking/lab/${date}/${id}`, { note: technicianNotes })
      .then(resp => {
        if (resp && resp.success) {
          toast.success("Booking Saved");
        }
      })
  }

  const saveColour = (colour) => {
    ApiService.put(`booking/lab/${date}/${id}/colour`, { colour: colour.hex })
      .then(resp => {
        if (resp && resp.success) {
          toast.success("Booking Colour Updated");
        }
      })
  }

  const getAttachment = (attachmentId) => {
    ApiService.get(`booking/lab/${date}/${id}/attachment/${attachmentId}`)
      .then(resp => {
        if (resp && resp.url) {
          window.open(resp.url, '_newtab');
        }
      });
  }

  const normalizePath = (pathValue) => (pathValue || "").replace(/\\/g, "/").replace(/^\/+/, "");

  const getChemicalDisplayName = (chemical) => {
    return String(chemical?.documentName || chemical?.DocumentName || chemical?.path || chemical?.Path || chemical?.partNumber || chemical?.PartNumber || "").trim();
  };

  const getSortedChemicals = (chemicals = []) => {
    return [...chemicals].sort((left, right) => {
      const leftName = getChemicalDisplayName(left).toLocaleLowerCase();
      const rightName = getChemicalDisplayName(right).toLocaleLowerCase();
      return leftName.localeCompare(rightName);
    });
  };

  const getChemicalSdsUrl = (chemical) => {
    const user = StorageService.get(StorageService.keys.user);
    const remotePath = normalizePath(chemical?.path || chemical?.Path);

    if (!user?.organisationId || !user?.sasToken || !remotePath) {
      return null;
    }

    return `${Constants.api.storageUrl}${user.organisationId}/${remotePath}?${user.sasToken}`;
  };

  const downloadChemicalSds = (chemical) => {
    const url = getChemicalSdsUrl(chemical);

    if (!url) {
      toast.error("Unable to resolve the SDS download link for this chemical.");
      return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const generateMiniSdsPack = async () => {
    const chemicals = getSortedChemicals(booking?.chemicals || []);

    if (!chemicals.length) {
      toast.info("There are no chemicals on this booking to include in the Mini SDS Pack.");
      return;
    }

    try {
      const { PDFDocument, rgb } = await import('pdf-lib');
      const doc = await PDFDocument.create();
      const font = await doc.embedFont('Helvetica');
      const textColor = rgb(0.07, 0.09, 0.22);
      const pageWidth = 595;
      const pageHeight = 842;

      const addCenteredText = (page, text, y, size = 18) => {
        page.drawText(text, {
          x: 72,
          y,
          size,
          font,
          color: textColor,
          maxWidth: pageWidth - 144,
        });
      };

      const embedLogoAsPng = async () => {
        const image = new Image();

        await new Promise((resolve, reject) => {
          image.onload = resolve;
          image.onerror = reject;
          image.src = logo;
        });

        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth || 354;
        canvas.height = image.naturalHeight || 61;

        const context = canvas.getContext('2d');
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);

        const pngDataUrl = canvas.toDataURL('image/png');
        const pngResponse = await fetch(pngDataUrl);
        const pngBytes = await pngResponse.arrayBuffer();

        return await doc.embedPng(new Uint8Array(pngBytes));
      };

      const coverPage = doc.addPage([pageWidth, pageHeight]);
      const logoImage = await embedLogoAsPng();
      coverPage.drawImage(logoImage, {
        x: 72,
        y: 760,
        width: 180,
        height: 32,
      });
      addCenteredText(coverPage, 'Mini SDS Pack', 700, 24);
      addCenteredText(coverPage, booking.practicalName || 'Practical', 660, 18);
      addCenteredText(coverPage, `Date: ${booking.bookingDate ? new moment(booking.bookingDate).format('dddd, LL') : 'N/A'}`, 630, 14);
      addCenteredText(coverPage, `Teacher: ${booking.userName || 'N/A'}`, 600, 14);
      addCenteredText(coverPage, `Room: ${booking.room || 'N/A'}`, 570, 14);
      addCenteredText(coverPage, `Class: ${booking.class || 'N/A'}`, 540, 14);

      const tocPage = doc.addPage([pageWidth, pageHeight]);
      addCenteredText(tocPage, 'Table of Contents', 780, 18);
      let tocY = 730;
      chemicals.forEach((chemical, index) => {
        tocY -= 26;
        tocPage.drawText(`${index + 1}. ${chemical.documentName || chemical.DocumentName || chemical.path || chemical.Path}`, {
          x: 72,
          y: tocY,
          size: 12,
          font,
          color: textColor,
          maxWidth: pageWidth - 144,
        });
      });

      for (const chemical of chemicals) {
        const url = getChemicalSdsUrl(chemical);
        if (!url) {
          continue;
        }

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Unable to download ${chemical.documentName || chemical.DocumentName || 'the selected SDS PDF'}.`);
        }

        const pdfBytes = await response.arrayBuffer();
        const sourcePdf = await PDFDocument.load(pdfBytes);
        const copiedPages = await doc.copyPages(sourcePdf, sourcePdf.getPageIndices());
        copiedPages.forEach((page) => doc.addPage(page));
      }

      const pdfBytes = await doc.save();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const fileUrl = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      downloadLink.href = fileUrl;
      downloadLink.download = `${(booking.practicalName || 'mini-sds-pack').replace(/[^a-z0-9]+/gi, '-').toLowerCase()}.pdf`;
      downloadLink.click();
      window.URL.revokeObjectURL(fileUrl);
      toast.success("Mini SDS Pack generated successfully.");
    } catch (error) {
      console.error(error);
      toast.error(error.message || 'Unable to generate the Mini SDS Pack.');
    }
  };

  return <Container className="mt--7" fluid>
    <Row>
      <Col className="mb-5 mb-xl-0" xl="12">
        <Card className="shadow">
          <CardBody>
            {!booking && <Row><Col xs={12} className="text-center"><Loader /></Col></Row>}
            {booking && <>
              <Row className={`d-flex align-items-center`}>
                <Col xs={12} md={6}>
                  <h6 className="text-uppercase ls-1 mb-0">Date</h6>
                  <h3>{new moment(booking.bookingDate).format("dddd, LL")}</h3>
                </Col>
                <Col xs={12} md={6}>
                  <h6 className="text-uppercase ls-1 mb-0">Time</h6>
                  <h3>
                    {booking.startPeriodName}
                    {booking.endPeriodName &&
                      booking.endPeriodName != booking.startPeriodName && (
                        <> - {booking.endPeriodName}</>
                      )}
                  </h3>
                </Col>
              </Row>
              <Row>
                <FormColumn label={`Year Level`}>
                  <h4>{booking.yearLevel}</h4>
                </FormColumn>

                <FormColumn label={`Topic`} columns={2}>
                  <h4>{booking.topic || '—'}</h4>
                </FormColumn>

                <FormColumn label={`Subject`} columns={2}>
                  <h4>{booking.practicalName || '—'}</h4>
                </FormColumn>

                <FormColumn label={`User`}>
                  <h4>{booking.userName}</h4>
                </FormColumn>

                <FormColumn label={`Year`}>
                  <h4>{booking.year || new moment(booking.createdUtc).format("YYYY")}</h4>
                </FormColumn>
              </Row>
              <Row>
                <FormColumn label={`Campus`}>
                  <h4>{booking.campus}</h4>
                </FormColumn>

                <FormColumn label={`Room`}>
                  <h4>{booking.room}</h4>
                </FormColumn>

                <FormColumn label={`Class`}>
                  <h4>{booking.class}</h4>
                </FormColumn>
              </Row>
              <Row>
                <FormColumn label={`Created On`}>
                  <h4>{new moment(booking.createdUtc).format("dddd, LL hh:mm:ss A")}</h4>
                </FormColumn>
                <FormColumn label={`Updated On`}>
                  <h4>{booking.updatedUtc ? new moment(booking.updatedUtc).format("dddd, LL hh:mm:ss A") : ''}</h4>
                </FormColumn>
              </Row>
              <Row>
                <FormColumn label={`Sets Required`} columns={2}>
                  <h4>{booking.setsRequired}</h4>
                </FormColumn>
                <FormColumn label={`Book Reference`} columns={2}>
                  <h4>{booking.bookReference}</h4>
                </FormColumn>
              </Row>
              <Row>
                <FormColumn label={`Technician Assistance Required`} columns={2}>
                  <h4>{booking.technicianAssistanceRequired == true ? 'Yes' : 'No'}</h4>
                </FormColumn>
              </Row>
              <Row>
                <FormColumn label={`Booking Notes`} columns={1}>
                  <h4>{booking.bookingNotes}</h4>
                </FormColumn>
              </Row>
              {user.isAdmin && <><Row>
                <FormColumn label={`Technician Notes`} columns={1}>
                  <Input type="textarea" name="TechnicianNotes" id="TechnicianNotes" rows={3} onChange={e => setTechnicianNotes(e.target.value)} value={technicianNotes} />
                  <Button
                    color="primary" size="sm"
                    type="button" disabled={technicianNotes == booking.technicianNotes} className={`mt-2 float-right`} onClick={saveTechnicianNotes}>Save</Button>
                </FormColumn>
              </Row>
                <hr className={`my-3`} />
                <Row>
                  <FormColumn label={`Colour`} columns={1}>
                    <div className={'mt-2'}><CirclePicker
                      onChangeComplete={saveColour}
                      width={'100%'} color={booking.color} colors={["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#17a1eb", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"]} /></div>
                  </FormColumn>
                </Row>
              </>}
              {getSortedChemicals(booking?.chemicals || []).length > 0 && <>
                <hr className={`my-3`} />
                <Row>
                  <Col xs={12}>
                    <h3>Chemicals in use</h3>
                    <ul className="mb-0">
                      {getSortedChemicals(booking?.chemicals || []).map((chemical) => (
                        <li key={chemical.id || chemical.DocumentName || chemical.documentName || chemical.path || chemical.Path}>
                          {chemical.documentName || chemical.DocumentName || chemical.path || chemical.Path}
                          {chemical.vendor || chemical.Vendor ? ` — ${chemical.vendor || chemical.Vendor}` : ""}
                          <Button color="link" size="sm" className="ml-2 p-0 align-baseline" onClick={() => downloadChemicalSds(chemical)}>Download SDS</Button>
                        </li>
                      ))}
                    </ul>
                    <Button color="primary" size="sm" className="mt-3" onClick={generateMiniSdsPack}>Generate Mini SDS Pack</Button>
                  </Col>
                </Row>
              </>}
              {booking.attachments && booking.attachments.length > 0 && <>
                <hr className={`my-3`} />
                <Row className={`d-flex align-items-center`}>
                  <Col xs={12} md={6}>
                    <h3>Attachments</h3>
                    {(booking.attachments || []).map(attachment => {
                      return <>
                        <p><a href={`#`} onClick={(e) => { e.preventDefault(); getAttachment(attachment.id); }}>{attachment.name}</a></p>
                      </>
                    })}
                  </Col>
                </Row></>
              }
              {(booking.risks || []).map(risk => {
                return <>
                  <hr className={`my-3`} />
                  <Row className={`d-flex align-items-center`}>
                    <Col xs={12}>
                      <h3>{risk.name} Risks</h3>
                    </Col>
                  </Row>
                  {(risk.hazards || []).map((hazard) => (
                    <>
                      <Row className="d-flex align-items-center mb-2">
                        <Col xs={6}>
                          {hazard.name}
                        </Col>
                        <Col xs={6}>
                          {hazard.value}
                        </Col>
                      </Row>
                    </>))}



                  <Row className="d-flex align-items-center mt-4">
                    <Col xs={6}>
                      <h4>Notes</h4>
                    </Col>
                    <Col xs={6}>
                      {risk.notes}
                    </Col>
                  </Row>
                </>
              })}
              <hr className={`my-3`} />
              <Row className="d-flex align-items-center my-2">
                <Col xs={6}>
                  <h4>Control Measures</h4>
                </Col>
              </Row>
              <Row className="d-flex align-items-center mb-2">
                <Col xs={4} className='bold'>
                  <b>Control Measure</b>
                </Col>

                <Col xs={4}>
                  <b>Mitigation</b>
                </Col>
                <Col xs={4}>
                  <b>Other</b>
                </Col>
              </Row>
              {(booking.controlMeasures || []).map((method) => (<Row key={method.name} className="d-flex align-items-center mb-2">
                <Col xs={4}>
                  {method.name}
                </Col>

                <Col xs={4}>
                  {(method.mitigations || []).filter(m => m !== 'Other').concat((method.mitigations || []).includes('Other') ? ['Other'] : []).map((m, i) => <div key={i}>{m}</div>)}
                </Col>
                <Col xs={4}>
                  {method.mitigationOther}
                </Col>
              </Row>
              ))}
              {user.isAdmin && <Row>
                <FormColumn label={`Notes`} columns={1}>
                  <h4>{booking.notes}</h4>
                </FormColumn>
              </Row>}
            </>}
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>;

});